import { JobPostings } from '@platform/client';
import { Modal } from '@platform/components';
import { useQueryClient } from '@tanstack/react-query';

interface DeleteJobPostingModalProps {
  isOpen: boolean;
  onClose: () => void;
  id: number;
  page: number;
  limit: number;
}

export const DeleteJobPostingModal = (props: DeleteJobPostingModalProps) => {
  const { isOpen, onClose, id, page, limit } = props;

  const queryClient = useQueryClient();

  const submitJobPosting = JobPostings.useDeleteJobPosting({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: JobPostings.getGetJobPostingsAdminQueryKey({
            limit: limit || 0,
            page: page || 0,
          }),
        });
      },
    },
  });

  const deleteJobPosting = async () => {
    submitJobPosting.mutate({
      data: {
        id,
      },
    });

    closeModal();
  };

  const closeModal = () => {
    onClose();
  };

  return (
    <Modal
      variant='dialog'
      title='Delete Job Posting'
      ignoreExtraPadding={true}
      isOpen={isOpen}
      headerDivision='divider'
      onClose={closeModal}
      primaryCTA={{
        text: 'Delete Job Posting',
        callback: deleteJobPosting,
      }}
      secondaryCTA={{
        text: 'Cancel',
        callback: closeModal,
      }}
    >
      <div className='md:w-[460px]'>
        <div className='flex flex-col gap-4 w-full'>
          Are you sure you want to delete this job posting?
        </div>
      </div>
    </Modal>
  );
};
